import { __exportAll } from "../../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../../validators/parse.js";
import { z } from "zod";
//#region src/cues/v1/media/cues/get/by-id.ts
var by_id_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var ResponseSchema = z.object({
	name: z.string(),
	position: z.string(),
	userId: z.string(),
	uuid: z.string(),
	visibility: z.enum([
		"private",
		"org",
		"public"
	])
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { by_id_exports };

//# sourceMappingURL=by-id.js.map